import React, { useEffect, useState } from "react";
import welcomeMountainImage from "../../../../assets/welcomeMountainImage.png";
import stoImg from "../../../../assets/stoImg.png";
import shizunImg from "../../../../assets/shizunCharacter.png";
import siyuImg from "../../../../assets/siyuCharacter.png";
import { ChevronRight } from "lucide-react";

const GuidesIntro = ({ onNext }) => {
  const [activeText, setActiveText] = useState(0);
  const [allTextsShown, setAllTextsShown] = useState(false);

  useEffect(() => {
    const timers = [
      setTimeout(() => setActiveText(1), 2000),
      setTimeout(() => setActiveText(2), 4000),
      setTimeout(() => {
        setActiveText(3);
        setAllTextsShown(true);
      }, 6000),
    ];
    return () => timers.forEach(clearTimeout);
  }, []);

  const handleContinue = () => {
    if (onNext && allTextsShown) {
      onNext();
    }
  };

  return (
    <div className="relative w-full max-h-screen bg-white overflow-hidden">
      {/* Background */}
      <div className="absolute bottom-20 left-0 w-full h-[45%]">
        <img
          src={welcomeMountainImage}
          alt="Background Mountain"
          className="w-full h-full object-cover"
        />
      </div>
      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col justify-between px-4 py-12">
        {/* Characters */}
        <div className="w-full max-w-7xl mx-auto mt-16 flex flex-col md:flex-row items-end justify-between gap-10">
          <Character
            image={stoImg}
            align="left"
            showText={activeText >= 1}
            text="Before we begin, I want you to meet two guides who'll help you grow in different ways."
          />
          <Character
            image={shizunImg}
            align="center"
            showText={activeText >= 2}
            text="I'm Shizun, your companion for introspection, ready to listen and support you on your journey."
          />
          <Character
            image={siyuImg}
            align="right"
            showText={activeText >= 3}
            text="I'm SiYu—your companion to analyse, probe, and grow. Let's discover your strengths together."
          />
        </div>
        <div className="mb-16 flex justify-center">
          <button 
            onClick={handleContinue}
            disabled={!allTextsShown}
            className="flex items-center gap-4 bg-[#54B0AF] hover:bg-teal-600 transition text-white px-10 py-4 rounded-[22px] text-lg md:text-[21px] font-gotham font-medium shadow-md disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-[#54B0AF]"
          >
            Continue Your Path
            <span className="bg-white rounded-full p-2">
              <ChevronRight className="w-4 h-4 text-black" />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GuidesIntro;

const Character = ({ image, align, showText, text }) => {
  const containerAlignment =
    align === "left"
      ? "items-start"
      : align === "right"
      ? "items-end"
      : "items-center";

  const textPosition =
    align === "left"
      ? "absolute -top-16 left-0 -translate-y-full text-left translate-x-[50%]"
      : align === "right"
      ? "absolute top-1/3 left-0 -translate-x-[65%] -translate-y-1/2 text-left"
      : "absolute top-[40%] left-0 -translate-x-[50%] -translate-y-1/2 text-left";

  return (
    <div className={`relative flex flex-col ${containerAlignment}`}>
      {/* Character Image */}
      <img
        src={image}
        alt="Guide Character"
        className="relative z-10 w-[160px] md:w-[330px] h-auto object-contain mt-[10%]"
      />
      {/* Text */}
      <p
        className={`
          ${textPosition}
          max-w-xs text-[#323232] font-gotham font-normal text-sm md:text-base leading-relaxed
          transition-all duration-700
          ${showText ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}
        `}
      >
        {text}
      </p>
    </div>
  );
};